import {
  FETCH_SURVEY_OFFICERS_REQUEST,
  FETCH_SURVEY_OFFICERS_SUCCESS,
  FETCH_SURVEY_OFFICERS_FAILURE,
  CREATE_SURVEY_OFFICER_REQUEST,
  CREATE_SURVEY_OFFICER_SUCCESS,
  CREATE_SURVEY_OFFICER_FAILURE,
  UPLOAD_SURVEY_OFFICERS_REQUEST,
  UPLOAD_SURVEY_OFFICERS_SUCCESS,
  UPLOAD_SURVEY_OFFICERS_FAILURE,
  UPDATE_SURVEY_OFFICER_REQUEST,
  UPDATE_SURVEY_OFFICER_SUCCESS,
  UPDATE_SURVEY_OFFICER_FAILURE,
  SET_UPLOAD_PROGRESS,
} from "../../actions/user-management/surveyOfficerActions";

const initialState = {
  loading: false,
  surveyOfficers: [],
  pagination: {
    page: 1,
    limit: 10,
    totalRecords: 0,
    totalPages: 0,
  },
  uploadProgress: 0,
  error: null,
};

const surveyOfficerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SURVEY_OFFICERS_REQUEST:
    case CREATE_SURVEY_OFFICER_REQUEST:
    case UPLOAD_SURVEY_OFFICERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_SURVEY_OFFICERS_SUCCESS:
      return {
        ...state,
        loading: false,
        surveyOfficers: action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };

    case CREATE_SURVEY_OFFICER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case UPLOAD_SURVEY_OFFICERS_SUCCESS:
      return {
        ...state,
        loading: false,
        uploadProgress: 0,
        error: null,
      };

    case SET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadProgress: action.payload,
      };

    case FETCH_SURVEY_OFFICERS_FAILURE:
    case CREATE_SURVEY_OFFICER_FAILURE:
    case UPLOAD_SURVEY_OFFICERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_SURVEY_OFFICER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_SURVEY_OFFICER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case UPDATE_SURVEY_OFFICER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default surveyOfficerReducer;
